/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserProfileResponse { 
    /**
     * Internal username from JWT (e.g., dk016191@broadcom.net)
     */
    internal_username: string;
    /**
     * User\'s actual email address (e.g., dhruv.khatri@broadcom.com)
     */
    email?: string;
    /**
     * User\'s first name
     */
    first_name?: string;
    /**
     * User\'s last name
     */
    last_name?: string;
    /**
     * CSP user ID
     */
    user_id?: string;
    /**
     * Organization ID
     */
    org_id?: string;
    /**
     * When the record was first created
     */
    created_time?: Date;
    /**
     * When the record was last updated
     */
    updated_time?: Date;
    /**
     * When the user profile was last synced from CSP API
     */
    last_synced_time?: Date;
}

